import { useState } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { getSuitableStars, mystar, abhivadhi } from '../services/panchangam-utils';

const T = { bg: '#f0f5e8', cream: '#fffef0', greenDk: '#1b5e20', maroon: '#6d1b1b', border: '#c8e6c9', header: 'linear-gradient(135deg, #090b72, #1a237e)' };

const NazhiConvertPage = () => {
  const [activeTab, setActiveTab] = useState(1);

  // 1. Muhurtham Vakyam
  const [muhurthamDate, setMuhurthamDate] = useState(dayjs().format('YYYY-MM-DD'));
  const [muhurthamStar, setMuhurthamStar] = useState('அஸ்விநி');
  const [muhurthamLagnam, setMuhurthamLagnam] = useState('மேஷ');
  const [fromTime, setFromTime] = useState(0.00);
  const [toTime, setToTime] = useState(0.00);
  
  // 2. Nazhi Convert
  const [nazhiVal, setNazhiVal] = useState(0);
  const nazhiToMani = (n) => {
    let mins = parseInt(n) * 60.0 + Math.round((n - parseInt(n)) * 100);
    let t1 = mins * 0.4;
    let t2 = Math.trunc(t1 / 60);
    let t3 = t1 - (t2 * 60);
    if (t3 >= 60) { t2++; t3 -= 60; }
    return (t2 + t3/100).toFixed(2);
  };

  // 3. Panchagam
  const [panchagamVals, setPanchagamVals] = useState({thithi: 1, vaaram: 1, nakshatram: 1, lagnam: 1, dhuruvam: 0});
  const getPanchagamTotal = () => parseInt(panchagamVals.thithi) + parseInt(panchagamVals.vaaram) + parseInt(panchagamVals.nakshatram) + parseInt(panchagamVals.lagnam) + parseInt(panchagamVals.dhuruvam);
  const getPanchagamRem = () => getPanchagamTotal() % 9;
  const getPariharam = (rem) => {
    switch (rem) {
      case 0: case 3: case 5: case 7: case 9: return { p: 'நிஷ்பஞ்சகம்', r: 'பரிகாரம் தேவையில்லை' };
      case 1: return { p: 'ம்ருத்யு பஞ்சகம்', r: 'ரத்தின தானம்' };
      case 2: return { p: 'அக்னி பஞ்சகம்', r: 'சந்தன தானம்' };
      case 4: return { p: 'ராஜ பஞ்சகம்', r: 'எலுமிச்சை தானம்' };
      case 6: return { p: 'சோர பஞ்சகம்', r: 'தீப தானம்' };
      case 8: return { p: 'ரோக பஞ்சகம்', r: 'தான்ய தானம்' };
      default: return { p: '', r: '' };
    }
  };

  // 4. Kasara Yogam
  const [kasaraDays, setKasaraDays] = useState(1);
  const getKasara = (d) => {
    const rem = parseInt(d) % 9;
    return [0,3,4,5,9].includes(rem) ? "கசர யோகம் உள்ளது" : "கசர யோகம் இல்லை";
  };

  // 5. Date Diff
  const [fDate, setFDate] = useState('');
  const [tDate, setTDate] = useState('');
  const diffDays = () => {
    if (!fDate || !tDate) return 0;
    const diffTime = Math.abs(new Date(tDate) - new Date(fDate));
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
  };

  // 6. Dhinaporutham
  const [selStar, setSelStar] = useState(1);
  const chanStarIdx = (selStar + 16) > 27 ? (selStar + 16) - 27 : (selStar + 16);
  
  // Helpers
  const renderHeader = (title) => (
    <div style={{ background: T.header, padding: '12px', borderRadius: '10px', textAlign: 'center', marginBottom: '15px' }}>
      <h1 style={{ color: '#fff', margin: 0, fontSize: '1.2rem', fontWeight: 900 }}>{title}</h1>
    </div>
  );

  return (
    <div style={{ background: T.bg, minHeight: '100vh', padding: '10px', fontFamily:'sans-serif' }}>
      
      <div style={{marginBottom:'15px'}}>
        <select 
          value={activeTab} 
          onChange={(e) => setActiveTab(parseInt(e.target.value))}
          style={{width:'100%', padding:'12px', borderRadius:'8px', border:'2px solid '+T.greenDk, fontWeight:'bold', fontSize:'1rem', color:T.greenDk, background:'#fff', outline:'none', cursor:'pointer'}}
        >
          {['முஹூர்த்த வாக்கியம்','நாழியை மணியாக்க','பஞ்சகமும் பரிகாரமும்','கசர யோகம்','மொத்த நாட்கள்','தினப்பொருத்தம்','அபிவாதி பட்டியல்'].map((name, i) => (
            <option key={i} value={i+1}>
              0{i+1}. {name}
            </option>
          ))}
        </select>
      </div>

      {activeTab === 1 && (
        <div style={{background:'#fff', padding:'15px', borderRadius:'10px', border:'1px solid '+T.border}}>
          {renderHeader('01. முஹூர்த்த வாக்கியம்')}
          <div style={{fontSize:'0.85rem', color:T.maroon, marginBottom:'15px'}}>முஹூர்த தேதி, லக்னம் தேர்வுசெய்து முஹூர்த்த ஆரம்ப -முடிவு நேரத்தை உள்ளிட்டால் நாழிகையுடன் முஹூர்த்த வாக்கியம் கிடைக்கும்.</div>
          
          <div style={{marginBottom:'10px'}}>
             <div style={{fontSize:'0.85rem', fontWeight:'bold'}}>தேதி:</div>
             <input type="date" value={muhurthamDate} onChange={e=>setMuhurthamDate(e.target.value)} style={{width:'100%', padding:'8px', borderRadius:'6px', border:'1px solid #ccc'}} />
          </div>

          <div style={{marginBottom:'10px'}}>
             <div style={{fontSize:'0.85rem', fontWeight:'bold'}}>நக்ஷத்ரம்:</div>
             <select value={muhurthamStar} onChange={e=>setMuhurthamStar(e.target.value)} style={{width:'100%', padding:'8px', borderRadius:'6px', border:'1px solid #ccc'}}>
               {['அஸ்விநி','பரணி','கார்த்திகை','ரோகிணி','மிருகசீர்ஷம்','திருவாதிரை','புனர்பூசம்','பூசம்','ஆயில்யம்','மகம்','பூரம்','உத்தரம்','ஹஸ்தம்','சித்திரை','ஸ்வாதி','விசாகம்','அநுஷம்','கேட்டை','மூலம்','பூராடம்','உத்ராடம்','திருவோணம்','அவிட்டம்','சதயம்','பூரட்டாதி','உத்ரட்டாதி','ரேவதி'].map(s => <option key={s} value={s}>{s}</option>)}
             </select>
          </div>

          <div style={{marginBottom:'10px'}}>
             <div style={{fontSize:'0.85rem', fontWeight:'bold'}}>லக்னம்:</div>
             <select value={muhurthamLagnam} onChange={e=>setMuhurthamLagnam(e.target.value)} style={{width:'100%', padding:'8px', borderRadius:'6px', border:'1px solid #ccc'}}>
               {['மேஷ','ரிஷப','மிதுன','கடக','சிம்ம','கன்யா','துலா','வ்ருச்சிக','தனுர்','மகர','கும்ப','மீன'].map(s => <option key={s} value={s}>{s}</option>)}
             </select>
          </div>

          <div style={{marginBottom:'10px'}}>
             <div style={{fontSize:'0.85rem', fontWeight:'bold'}}>ஆரம்பநேரம் IST (HH.MM):</div>
             <input type="number" step="0.01" value={fromTime} onChange={e=>setFromTime(e.target.value)} style={{width:'100%', padding:'8px', borderRadius:'6px', border:'1px solid #ccc'}} />
          </div>

          <div style={{marginBottom:'20px'}}>
             <div style={{fontSize:'0.85rem', fontWeight:'bold'}}>முடிவு நேரம் IST (HH.MM):</div>
             <input type="number" step="0.01" value={toTime} onChange={e=>setToTime(e.target.value)} style={{width:'100%', padding:'8px', borderRadius:'6px', border:'1px solid #ccc'}} />
          </div>

          <div style={{background:T.cream, padding:'15px', borderRadius:'8px', border:'1px dotted orange', lineHeight:'1.8'}}>
             இப்பவும் நாளது மங்களகரமான வருடம் மாதம் தேதி ({dayjs(muhurthamDate).format('DD - MM - YYYY')}) கிழமை, {muhurthamStar} நக்ஷத்ரம் கூடிய சுபயோக சுப தினத்தில், உதயாதி நாழிகைக்கு மேல் நாழிகைக்குள் ( {fromTime} am To {toTime} am ) {muhurthamLagnam} லக்னத்தில் ...
          </div>
        </div>
      )}

      {activeTab === 2 && (
        <div style={{background:'#fff', padding:'15px', borderRadius:'10px', border:'1px solid '+T.border}}>
          {renderHeader('02. நாழியை மணியாக்க')}
          <div style={{fontSize:'0.85rem', color:T.maroon, marginBottom:'15px'}}>தேவையான நாழியை மணி நிமிடமாக மாற்ற கீழுள்ள பெட்டியில் நாழியை உள்ளிடவும்.</div>
          
          <div style={{marginBottom:'15px'}}>
             <div style={{fontSize:'0.85rem', fontWeight:'bold'}}>நாழிகை:</div>
             <input type="number" step="0.01" value={nazhiVal} onChange={e=>setNazhiVal(e.target.value)} style={{width:'100%', padding:'10px', borderRadius:'6px', border:'1px solid #ccc', fontSize:'16px'}} />
          </div>
          
          <div style={{background:T.header, padding:'15px', borderRadius:'8px', color:'#fff', textAlign:'center', fontSize:'1.2rem', fontWeight:'bold'}}>
             {nazhiVal} நாழி = {nazhiToMani(nazhiVal)} மணி -நிமி
          </div>
        </div>
      )}

      {activeTab === 3 && (
        <div style={{background:'#fff', padding:'15px', borderRadius:'10px', border:'1px solid '+T.border}}>
          {renderHeader('03. பஞ்சகமும் பரிகாரமும்')}
          <div style={{fontSize:'0.85rem', color:T.maroon, marginBottom:'15px'}}>ஜோதிடர்கள், வாத்யார்கள் தேவையான லக்னத்திற்கு துருவத்துடனோ அன்றியோ பஞ்சகம் பார்க்க கீழுள்ள நிரலியை உபயோகிக்கவும்.</div>
          
          {[{k:'thithi',l:'திதி',max:15},{k:'vaaram',l:'வாரம்(கிழ)',max:7},{k:'nakshatram',l:'நக்ஷத்ரம்',max:27},{k:'lagnam',l:'லக்னம்',max:12}].map(f => (
             <div key={f.k} style={{display:'flex', marginBottom:'10px', alignItems:'center'}}>
                <div style={{width:'40%', fontSize:'0.85rem', fontWeight:'bold'}}>{f.l} :</div>
                <select value={panchagamVals[f.k]} onChange={e=>setPanchagamVals({...panchagamVals, [f.k]: e.target.value})} style={{width:'60%', padding:'8px', borderRadius:'6px'}}>
                  {Array.from({length:f.max}).map((_,i) => <option key={i+1} value={i+1}>{i+1}</option>)}
                </select>
             </div>
          ))}

          <div style={{display:'flex', marginBottom:'15px', alignItems:'center'}}>
            <div style={{width:'40%', fontSize:'0.85rem', fontWeight:'bold'}}>துருவம் * :</div>
            <select value={panchagamVals.dhuruvam} onChange={e=>setPanchagamVals({...panchagamVals, dhuruvam: e.target.value})} style={{width:'60%', padding:'8px', borderRadius:'6px'}}>
               <option value={2}>மகர-2</option><option value={4}>கும்ப-4</option><option value={6}>மீன-6</option>
               <option value={5}>மேஷ-5</option><option value={7}>ரிஷ-7</option><option value={0}>மற்றவை-0</option>
            </select>
          </div>
          
          <div style={{background:T.cream, padding:'15px', borderRadius:'8px', border:'1px dotted orange'}}>
             <div style={{display:'flex', justifyContent:'space-between', borderBottom:'1px solid #ccc', paddingBottom:'5px', marginBottom:'5px'}}>
               <span style={{fontWeight:'bold'}}>மொத்தம்:</span><span>{getPanchagamTotal()}</span>
             </div>
             <div style={{display:'flex', justifyContent:'space-between', borderBottom:'1px solid #ccc', paddingBottom:'5px', marginBottom:'10px'}}>
               <span style={{fontWeight:'bold'}}>9ல் வகுத்த மீதி:</span><span>{getPanchagamRem()}</span>
             </div>
             <div style={{fontSize:'1.1rem', fontWeight:'bold', color:T.greenDk, textAlign:'center'}}>
               பஞ்சகம்: {getPariharam(getPanchagamRem()).p}
             </div>
             <div style={{fontSize:'1.1rem', fontWeight:'bold', color:T.maroon, textAlign:'center', marginTop:'5px'}}>
               பரிகாரம்: {getPariharam(getPanchagamRem()).r}
             </div>
          </div>
        </div>
      )}

      {activeTab === 4 && (
        <div style={{background:'#fff', padding:'15px', borderRadius:'10px', border:'1px solid '+T.border}}>
          {renderHeader('04. கசர யோகமும் பலனும்')}
          <div style={{fontSize:'0.85rem', color:T.maroon, marginBottom:'15px'}}>சூரியனின் க்ரஹபாத சாரத்தைப் பார்த்து, தாங்கள் தேர்ந்தெடுக்கும் நாளுக்கு முன்னதாக சூரியன் எந்த நக்ஷத்ரத்தில் உள்ளது என அறியவும். அடுத்து தாங்கள் தேர்வு செய்த நாளின் நக்ஷத்ரம் வரை எண்ணி வரும் எண்ணிக்கையை கீழே நிரலியில் உள்ளிடவும்.</div>
          
          <div style={{display:'flex', alignItems:'center', marginBottom:'20px'}}>
             <div style={{width:'30%', fontSize:'0.9rem', fontWeight:'bold'}}>நாட்கள்:</div>
             <input type="number" step="1" value={kasaraDays} onChange={e=>setKasaraDays(e.target.value)} style={{width:'70%', padding:'10px', borderRadius:'6px', border:'1px solid #ccc'}} />
          </div>

          <div style={{background:T.header, padding:'15px', borderRadius:'8px', color:'#fff', textAlign:'center', fontSize:'1.1rem', fontWeight:'bold'}}>
             தீர்வு: {kasaraDays} - {getKasara(kasaraDays)}
          </div>
        </div>
      )}

      {activeTab === 5 && (
        <div style={{background:'#fff', padding:'15px', borderRadius:'10px', border:'1px solid '+T.border}}>
          {renderHeader('05. தேதி-மறு தேதி மொத்த நாட்கள்')}
          <div style={{fontSize:'0.85rem', color:T.maroon, marginBottom:'15px'}}>ஆரம்ப - முடிவு தேதிகளைத் தேர்வு செய்தால் ஆரம்ப தேதி சேர்த்து முடிவு தேதிவரையிலான மொத்த நாட்கள் விடையாகக் கிடைக்கும்.</div>
          
          <div style={{marginBottom:'10px'}}>
             <div style={{fontSize:'0.85rem', fontWeight:'bold'}}>ஆரம்ப தேதி:</div>
             <input type="date" value={fDate} onChange={e=>setFDate(e.target.value)} style={{width:'100%', padding:'8px', borderRadius:'6px', border:'1px solid #ccc'}} />
          </div>
          <div style={{marginBottom:'20px'}}>
             <div style={{fontSize:'0.85rem', fontWeight:'bold'}}>முடிவு தேதி:</div>
             <input type="date" value={tDate} onChange={e=>setTDate(e.target.value)} style={{width:'100%', padding:'8px', borderRadius:'6px', border:'1px solid #ccc'}} />
          </div>

          <div style={{background:T.header, padding:'15px', borderRadius:'8px', color:'#fff', textAlign:'center', fontSize:'1.1rem', fontWeight:'bold'}}>
             ஆரம்பநாளுடன் மொத்தம்: {diffDays()} <br/>
             <span style={{fontSize:'0.9rem', color:'#ffc107'}}>இடை நாட்கள் மட்டும்: {diffDays() > 0 ? diffDays() - 1 : 0}</span>
          </div>
        </div>
      )}

      {activeTab === 6 && (
        <div style={{background:'#fff', padding:'15px', borderRadius:'10px', border:'1px solid '+T.border}}>
          {renderHeader('06. தினப்பொருத்தம்')}
          <div style={{fontSize:'0.85rem', color:T.maroon, marginBottom:'15px'}}>தினப்பொருத்தம் உள்ள நக்ஷத்திரங்களில் சந்த்ராஷ்டம நக்ஷத்திரங்களை அறிந்து அவற்றை விலக்கிவிடவும். சந்த்ராஷ்டமம் நீக்கப்பட்ட தினப்பொருத்தம் உள்ள நக்ஷத்திரங்கள் மட்டுமே பட்டியலிடப்பட்டுளன.</div>
          
          <div style={{marginBottom:'15px'}}>
             <div style={{fontSize:'0.85rem', fontWeight:'bold'}}>தங்கள் நக்ஷத்திரம்:</div>
             <select value={selStar} onChange={e=>setSelStar(parseInt(e.target.value))} style={{width:'100%', padding:'10px', borderRadius:'6px', border:'1px solid #ccc'}}>
               {mystar ? mystar.slice(1).map(s => <option key={s.value} value={s.value}>{s.name}</option>) : 
                 ['அஸ்விநி','பரணி','கார்த்திகை','ரோகிணி','மிருகசீர்ஷம்','திருவாதிரை','புனர்பூசம்','பூசம்','ஆயில்யம்','மகம்','பூரம்','உத்தரம்','ஹஸ்தம்','சித்திரை','ஸ்வாதி','விசாகம்','அநுஷம்','கேட்டை','மூலம்','பூராடம்','உத்ராடம்','திருவோணம்','அவிட்டம்','சதயம்','பூரட்டாதி','உத்ரட்டாதி','ரேவதி'].map((s, i) => <option key={i+1} value={i+1}>{s}</option>)
               }
             </select>
          </div>

          <div style={{background:T.cream, padding:'15px', borderRadius:'8px', border:'1px dotted orange'}}>
             <div style={{display:'flex', borderBottom:'1px solid #ccc', paddingBottom:'8px', marginBottom:'8px'}}>
               <span style={{fontWeight:'bold', width:'50%', color:T.greenDk}}>சந்த்ராஷ்டமம் :</span>
               <span style={{fontWeight:'bold', width:'50%', color:'red'}}>
                 {mystar ? mystar[chanStarIdx].name : ''}
               </span>
             </div>
             <div>
               <div style={{fontWeight:'bold', color:T.greenDk, marginBottom:'8px'}}>தினப்பொருத்தம் :</div>
               <div style={{lineHeight:'1.8'}}>
                 {mystar && getSuitableStars ? getSuitableStars(selStar).map(s => (
                   <span key={s} style={{display:'inline-block', margin:'4px', padding:'4px 8px', background:'#e8f5e9', borderRadius:'4px', fontSize:'0.85rem'}}>{s}</span>
                 )) : 'பொருத்தம் லோட் ஆகிறது...'}
               </div>
             </div>
          </div>
        </div>
      )}

      {activeTab === 7 && (
        <div style={{background:'#fff', padding:'15px', borderRadius:'10px', border:'1px solid '+T.border}}>
          {renderHeader('07. அபிவாதி பட்டியல்')}
          <div style={{fontSize:'0.85rem', color:T.maroon, marginBottom:'15px'}}>கோத்ரம் மற்றும் ப்ரவரம் பட்டியல்.</div>
          
          <table style={{width:'100%', borderCollapse:'collapse', fontSize:'0.85rem'}}>
            <thead>
              <tr style={{background:'#e8f5e9', color:T.greenDk}}>
                <th style={{padding:'8px', border:'1px solid #ccc'}}>எண்</th>
                <th style={{padding:'8px', border:'1px solid #ccc'}}>கோத்ரம்</th>
                <th style={{padding:'8px', border:'1px solid #ccc'}}>ப்ரவரம்</th>
              </tr>
            </thead>
            <tbody>
              {abhivadhi ? abhivadhi.map((a, i) => (
                <tr key={i}>
                  <td style={{padding:'6px', border:'1px solid #ccc', textAlign:'center'}}>{a.Sno}</td>
                  <td style={{padding:'6px', border:'1px solid #ccc'}}>{a.Gothram}</td>
                  <td style={{padding:'6px', border:'1px solid #ccc'}}>{a.Pravaram}</td>
                </tr>
              )) : (
                <tr><td colSpan="3" style={{textAlign:'center', padding:'20px'}}>பட்டியல் லோட் ஆகிறது...</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}

    </div>
  );
};

export default NazhiConvertPage;